import React from 'react';
import {
    FaShieldAlt,
    FaSyncAlt,
    FaExclamationTriangle,
    FaCheckCircle,
    FaInfoCircle
} from 'react-icons/fa';
import './style.css';
import ButtonGroupNew from '../Form/forms/BusinessLiteForms/components/ButtonGroupNew';
import { useTranslation } from '../../store/context/TranslationContext';

const EnhancedDueDiligence = ({ handleNext }) => {
    const { t } = useTranslation();
    return (
        <div className="edd-container">
            <div className="edd-header">
                <div className="edd-header-badge">
                    <FaShieldAlt className="edd-icon-blue" />
                    <h1>{t("Enhanced Due Diligence")}</h1>
                </div>
                {/* <p>{t("Keeping your financial information accurate and up-to-date")}</p> */}
            </div>

            <div className="edd-section edd-info-section">
                <div className="edd-section-header">
                    <FaInfoCircle className="edd-icon-blue" color='#4b5563' />
                    <h2 className="edd-section-title">{t("What is a periodic review?")}</h2>
                </div>
                <p className="edd-section-content ps-4">
                    {t("As part of our commitment to providing you with safe and reliable banking services, we regularly update the information we hold about our customers. This process, known as a Periodic Review (or in some cases Enhanced Due Diligence), is a standard regulatory requirement for all banks.")}
                </p>
            </div>

            <div className="edd-grid">
                <div className="edd-box edd-box-green">
                    <div className="edd-box-header">
                        <FaShieldAlt className="edd-icon-green" />
                        <h3 className="edd-box-title">{t("Why we do this")}</h3>
                    </div>
                    <ul className="edd-list">
                        <li>{t("Keep your account information accurate and up to date.")}</li>
                        <li>{t("Comply with financial regulations.")}</li>
                        <li>{t("Protect your account from potential financial crime or misuse.")}</li>
                        <li>{t("Continue to enjoy our banking services.")}</li>
                    </ul>
                </div>

                {/* How Section */}
                <div className="edd-box edd-box-amber">
                    <div className="edd-box-header">
                        <FaSyncAlt className="edd-icon-amber" />
                        <h3 className="edd-box-title">{t("How it works")}</h3>
                    </div>
                    <ul className="edd-list">
                   
                        <li>{t("Review the information we have on file for you.")}</li>
                        <li>{t("If there's no change, please confirm the information displayed.")}</li>
                        <li>{t("If there's any change to the information displayed, please update it.")}</li>
                        <li>{t("The updated information is highlighted in yellow.")}</li>
                        <li>{t("Submit the Periodic Review form along with any supporting documents.")}</li>
                        <li>{t("Our team will reach out to you if they have any questions.")}</li>
                        <li>{t("If our team has no questions, your information will be updated.")}</li>
                    </ul>
                </div>
            </div>

            {/* <div className="edd-changed-section">
                <div className="edd-section-header">
                    <FaExclamationTriangle className="edd-icon-warning" />
                    <h3 className="edd-section-title">{t("About Changed Fields")}</h3>
                </div>
                <div className="edd-changed-demo">
                    <span className="edd-highlight-field">{t("Example Field")}</span>
                    <div>
                        <p className='mb-2'><strong>{t("Appears in yellow when:")}</strong></p>
                        <ul className="edd-list">
                            <li>{t("You've updated information since account creation")}</li>
                            <li>{t("Our records need reconfirmation")}</li>
                        </ul>
                    </div>
                </div>
                <p className="edd-section-content">
                    {t("Simply verify yellow-highlighted fields. We may ask for supporting documents.")}
                </p>
            </div> */}

            <div className="edd-section edd-next-steps">
                <div className="edd-section-header">
                    <FaCheckCircle className="edd-icon-success" />
                    <h3 className="edd-section-title">{t("What to expect?")}</h3>
                </div>
                <p>{t("We will display the information we have on the account for you and you can select the right option.")}</p>
                <div className="edd-steps-grid">
                    <div className="edd-step-card edd-step-success">
                        <div className="edd-step-header">
                            <span className="edd-step-badge edd-badge-success">✓</span>
                            <p className="edd-box-title">{t("No Change")}</p>
                        </div>
                        <p>{t('Choose "No Change" at the bottom of each page if you are confirming the accuracy of the information.')}</p>
                    </div>
                    <div className="edd-step-card edd-step-warning">
                        <div className="edd-step-header">
                            <span className="edd-step-badge edd-badge-warning">!</span>
                            <p className="edd-box-title">{t("Change Identified")}</p>
                        </div>
                        <p>{t('Choose "Edit" to update the relevant information and submit for approval.')}</p>
                    </div>
                </div>
            </div>

            <div className="edd-footer">
                <p>
                    {t("This process helps us uphold the highest standards for your financial safety. ")}
                    {t("Thank you for keeping your information up-to-date!")}
                </p>
            </div>

            <div className='mt-5'>
                <ButtonGroupNew
                    onNextClick={() => { handleNext() }}
                    step={1}
                    showPageNum={false}
                    pageNum={1}
                    hideBackButton
                    asLabel={false}
                />
            </div>
        </div>
    );
};

export default EnhancedDueDiligence;